import React from 'react'
const CBAlert = ({
 children,
 type="info",
 message=''
}) => {
  return (
    <div className={`flex justify-center border text-neutral_4  font-sarabun items-center  rounded-md m-1  p-2 ${type == 'info' && 'border-blue_highlight bg-neutral_1'} ${type == 'error' && 'border-burnt bg-neutral_1'} cursor-pointer` }>
      {children}
      {message}
    </div>
  )
}

export { CBAlert }
